'use client';
import { Arrow as Arrow2, CheckboxItem as CheckboxItem2, Content as Content2, ContextMenu as ContextMenu$1, ContextMenuArrow as ContextMenuArrow$1, ContextMenuCheckboxItem as ContextMenuCheckboxItem$1, ContextMenuContent as ContextMenuContent$1, ContextMenuGroup as ContextMenuGroup$1, ContextMenuItem as ContextMenuItem$1, ContextMenuItemIndicator as ContextMenuItemIndicator$1, ContextMenuLabel as ContextMenuLabel$1, ContextMenuPortal as ContextMenuPortal$1, ContextMenuRadioGroup as ContextMenuRadioGroup$1, ContextMenuRadioItem as ContextMenuRadioItem$1, ContextMenuSeparator as ContextMenuSeparator$1, ContextMenuSub as ContextMenuSub$1, ContextMenuSubContent as ContextMenuSubContent$1, ContextMenuSubTrigger as ContextMenuSubTrigger$1, ContextMenuTrigger as ContextMenuTrigger$1, Group as Group2, Item as Item2, ItemIndicator as ItemIndicator2, Label as Label2, Portal as Portal2, RadioGroup as RadioGroup2, RadioItem as RadioItem2, Root as Root2, Separator as Separator2, Sub as Sub2, SubContent as SubContent2, SubTrigger as SubTrigger2, Trigger as Trigger$1 } from '../../packages/subframe-core/external/@radix-ui/react-context-menu/dist/index.js';

var Arrow = Arrow2;
var CheckboxItem = CheckboxItem2;
var Content = Content2;
var ContextMenu = ContextMenu$1;
var ContextMenuArrow = ContextMenuArrow$1;
var ContextMenuCheckboxItem = ContextMenuCheckboxItem$1;
var ContextMenuContent = ContextMenuContent$1;
var ContextMenuGroup = ContextMenuGroup$1;
var ContextMenuItem = ContextMenuItem$1;
var ContextMenuItemIndicator = ContextMenuItemIndicator$1;
var ContextMenuLabel = ContextMenuLabel$1;
var ContextMenuPortal = ContextMenuPortal$1;
var ContextMenuRadioGroup = ContextMenuRadioGroup$1;
var ContextMenuRadioItem = ContextMenuRadioItem$1;
var ContextMenuSeparator = ContextMenuSeparator$1;
var ContextMenuSub = ContextMenuSub$1;
var ContextMenuSubContent = ContextMenuSubContent$1;
var ContextMenuSubTrigger = ContextMenuSubTrigger$1;
var ContextMenuTrigger = ContextMenuTrigger$1;
var Group = Group2;
var Item = Item2;
var ItemIndicator = ItemIndicator2;
var Label = Label2;
var Portal = Portal2;
var RadioGroup = RadioGroup2;
var RadioItem = RadioItem2;
var Root = Root2;
var Separator = Separator2;
var Sub = Sub2;
var SubContent = SubContent2;
var SubTrigger = SubTrigger2;
var Trigger = Trigger$1;

export { Arrow, CheckboxItem, Content, ContextMenu, ContextMenuArrow, ContextMenuCheckboxItem, ContextMenuContent, ContextMenuGroup, ContextMenuItem, ContextMenuItemIndicator, ContextMenuLabel, ContextMenuPortal, ContextMenuRadioGroup, ContextMenuRadioItem, ContextMenuSeparator, ContextMenuSub, ContextMenuSubContent, ContextMenuSubTrigger, ContextMenuTrigger, Group, Item, ItemIndicator, Label, Portal, RadioGroup, RadioItem, Root, Separator, Sub, SubContent, SubTrigger, Trigger };
